import { useCallback, useEffect, useState } from 'react';

import useBroadcastChannel, {
  BroadcastActions,
  BroadcastChannels,
  BroadcastMessage,
} from 'modules/Broadcast/useBroadcastChannel';
import logger from 'utils/logging/faro';

type UseTabBroadcastChannelProps = {
  tabId: string;
  onForceClaim: (senderTabId: string) => void;
};

export default function useTabBroadcastChannel({ tabId, onForceClaim }: UseTabBroadcastChannelProps) {
  const [message, setMessage] = useState<BroadcastMessage | null>(null);
  const { sendMessage, channel } = useBroadcastChannel(BroadcastChannels.WINDOW_LOCK, setMessage);

  const sendForceClaim = useCallback(() => {
    sendMessage({
      type: BroadcastActions.FORCE_CLAIM,
      payload: { tabId, sessionId: logger.sessionId },
    });
  }, [sendMessage, tabId]);

  useEffect(() => {
    if (!message || !message.payload) return;
    if (message.type === BroadcastActions.FORCE_CLAIM && message.payload?.tabId !== tabId) {
      const { tabId: newMainTabId, sessionId } = message.payload;
      logger.info(`App control was force-claimed by tab: ${newMainTabId}`, { newMainSession: sessionId });

      onForceClaim(newMainTabId);
      channel.close();
    }
  }, [message, tabId, onForceClaim, channel]);

  return { sendForceClaim, channel };
}
